import { Observable } from 'rxjs';
import { UserRepository } from '../domain/user/repository';

import HttpClient from '../utils/http-client';

export class UserRepositoryImplementation extends UserRepository {
  passwordRecovery(data: any): Observable<void> {
    const httpClient = new HttpClient("", "");
    return httpClient.post_no_refresh<any>(`/regist/forgot-password`, data);
  }

  create(user: any): Observable<any> {
    const httpClient = new HttpClient("", "");
    return httpClient.post_no_refresh<any>(`/regist`, user);
  }

  update(uid: string, cid: string | null, payload: any): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.put<any>(`/user`, payload);
  }

  get(uid: string, cid: string | null): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.get<any>(`/user`);
  }

  getSharedProfiles(uid: string, cid: string | null): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.get<any>(`v1/shared`);
  }

  listIdTypes(uid: string, cid: string | null): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.get<any>(`v1/idType`);
  }

  roleVerify(uid: string, cid: string | null): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.get<any>(`role-verify`);
  }

  uploadAvatar(uid: string, cid: string | null, file: File): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    const formData = new FormData();
    formData.append('image', file)
    return httpClient.post<any>(`/user/avatar`, formData);
  }

  updatePassword(uid: string, cid: string | null, password: string): Observable<any> {
    const httpClient = new HttpClient(uid, cid);
    return httpClient.put<any>(`/user`, { password });
  }
}
